import { Questionnaire } from "./questionaries.model";
import { QuestionaryCore, QuestionnaireResponse } from "./questionnaire-response";


export const createQuestionaryForApi = <T extends QuestionaryCore>( {patientId, question, userId, diagnosisId}: {patientId: string , userId: string , question: T, diagnosisId: string} ): QuestionnaireResponseAPIObject<T> => {
  return {
   patientId,
   practitionerId: userId,
   questions: question,
   diagnosisId
  }
}

export interface  QuestionnaireResponseAPIObject<T extends QuestionaryCore> {

  patientId: string;
  practitionerId: string;
  diagnosisId: string;
  questions: T;
}

export class _QuestionnaireResponseAPIObject<T extends Questionnaire> implements QuestionnaireResponseAPIObject<T> {

  patientId: string;
  practitionerId: string;
  questions: T;
  diagnosisId: string;

  constructor() {

    this.patientId = '';
    this.practitionerId = '';
    this.questions = {} as T;
    this.diagnosisId = '';
  }

  setNewAPIResponse(questionnaire: T, patientId: string, practitionerId: string, diagnosisId: string): void {

    this.patientId = patientId;
    this.practitionerId = practitionerId;
    this.questions = questionnaire;
    this.diagnosisId = diagnosisId;
  }
}

